import { useEffect } from 'react';

import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import GroupIcon from '@material-ui/icons/GroupOutlined';
import { Skeleton } from '@material-ui/lab';

import { useAppDispatch, useAppSelector } from 'store';
import {
  EquipeInterface,
  equipesSelector,
  fetchEquipes,
} from 'store/reducers/equipes';

type ListaEquipesProps = {
  onSelect: (equipe: EquipeInterface) => void;
};

export default function ListaEquipes({ onSelect }: ListaEquipesProps) {
  const dispatch = useAppDispatch();
  const { equipes, loadingEquipes } = useAppSelector(equipesSelector);

  useEffect(() => {
    dispatch(fetchEquipes());
  }, [dispatch]);

  const items = loadingEquipes
    ? Array.from(new Array(3) as EquipeInterface[])
    : equipes;
  const renderEquipes = items.map((equipe, index) => {
    const key = equipe ? equipe.id : index;

    if (equipe) {
      return (
        <ListItem key={key} onClick={() => onSelect(equipe)} button>
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText
            primary={equipe.nome}
            primaryTypographyProps={{
              variant: 'body2',
            }}
          />
        </ListItem>
      );
    }

    return (
      <ListItem key={key}>
        <ListItemAvatar>
          <Skeleton variant="circle">
            <Avatar />
          </Skeleton>
        </ListItemAvatar>
        <ListItemText primary={<Skeleton variant="rect" />} />
      </ListItem>
    );
  });

  return (
    <List style={{ padding: 0 }}>
      <Typography
        style={{ marginBottom: 8 }}
        color="textSecondary"
        variant="body2"
      >
        Selecione a equipe na qual deseja realizar a transferência.
      </Typography>

      {renderEquipes}

      {!loadingEquipes && equipes.length <= 0 && (
        <ListItem disableGutters>
          <ListItemText secondary="Não encontramos nenhuma equipe no momento" />
        </ListItem>
      )}
    </List>
  );
}
